export default __webpack_public_path__ + "img/CKDipwmL.c1276960.svg";